import { render, staticRenderFns } from "./additional-traveler-bags.vue?vue&type=template&id=4498dc6a&scoped=true&"
import script from "./additional-traveler-bags.vue?vue&type=script&lang=js&"
export * from "./additional-traveler-bags.vue?vue&type=script&lang=js&"
import style0 from "./additional-traveler-bags.vue?vue&type=style&index=0&id=4498dc6a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4498dc6a",
  null
  
)

export default component.exports